<div
  class="flex max-w-[370px] flex-col rounded-[10px] bg-blanco text-start text-cafe shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
  <div>
    <ln-ln-image-frame
      [src]="imagePath"
      alt="Imagen del producto"
      [class]="'h-[220px] w-full rounded-t-[10px] object-cover'">
    </ln-ln-image-frame>
  </div>
  <div class="px-[18px] py-[15px] text-2xl font-semibold text-verde">
    {{ name }}
  </div>
  <div class="px-[18px] text-base font-semibold">
    {{ question }}
  </div>

  <div class="px-[18px] py-[15px] text-base">
    {{ answer }}
  </div>
  <div class="flex w-full flex-row justify-end pb-[18px] pr-[13px]">
    <button class=" text-end text-sm font-medium text-verde" (click)="navigateToServiceDetails()">
      {{ 'labels.moreInfo' | transloco }}
    </button>
  </div>
</div>
